import api from "./axios";
import { getCookie } from "../hooks/useCookies";

const token = getCookie("token");

export const updateAge = async (userDetails) => {
    try {
        const response = await api.put(`/api/v1/customer/user/preferences/save/age`, userDetails, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const updateGender = async (userDetails) => {
    try {
        const response = await api.put(`/api/v1/customer/user/preferences/save/gender_id`, userDetails, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}